var render = function render(){var _vm=this,_c=_vm._self._c;return _c('new-layout',{attrs:{"backgroundImage":_vm.backgroundImage,"backgroundImage2x":_vm.backgroundImage2x,"showLogo":false}},[_c('AccessSucceedCard',{staticClass:"success-card"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }